import React from 'react'
import { Header } from './Header'

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex h-screen layout-container">
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Header />
        <main className="page-main flex-1 overflow-x-hidden overflow-y-auto p-6 gradient-main min-w-0">
          <div className="max-w-6xl mx-auto w-full min-w-0">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}
